import Icon from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { ReactComponent as GeosecmaIcon } from 'lib/icons/geosecma-background.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router-dom';
import styled from 'styled-components';

const SelectCol = styled(Col)`
  height: 100%;
  border-left: 1px solid #f0f2f5;
  transition: flex 0.5s;
  background-color: white;
  display: flex;
  justify-content: center;
`;
const StyledContainer = styled.div`
  margin-top: 7%;
`;
const StyledBackgroundIcon = styled(Icon)`
  position: absolute;
  left: -15px;
  bottom: -50px;
  font-size: 35em;
`;
const StyledTypeContainer = styled.div`
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
  text-align: center;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 1.5em;
  border-radius: 5px;
  z-index: 2;
`;

const StyledButtonContainer = styled.div`
  margin: 15px;
`;

const StyledHeader = styled.h1`
  text-align: center;
  color: #231f20;
  font-size: 2em;
  margin-bottom: 25px;
`;
const StyledFlexbox = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const StyledDescriptionDiv = styled.div`
  width: calc(100% - 30px);
  font-size: 0.6em;
  height: 3em;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 25px;
  margin-right: 25px;
`;

function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
/**
 * Component where you will choose active tenant
 *
 * @param {*} tenants
 */
const SelectMunicipality = ({ tenants }) => {
  const [t] = useTranslation();
  if (tenants.length === 1) {
    return <Navigate to={`/${tenants[0].tenantId}`} />;
  }
  return (
    <Row style={{ height: '100vh', overflow: 'hidden' }} wrap={false}>
      <SelectCol flex="1 1 100%" key="selectCase">
        <StyledContainer>
          <StyledHeader>{t('general:chooseMunicipality')}</StyledHeader>
          <StyledFlexbox>
            {tenants
              .sort((a, b) => (a.tenantId.toLowerCase() > b.tenantId.toLowerCase() ? 1 : -1))
              .map(tenant => (
                <StyledTypeContainer key={tenant.tenantId}>
                  {tenant.icon?.content ? (
                    <img width="200" height="200" src={`${tenant.icon.content}`} alt={t('preview:municipalityLogo')} />
                  ) : (
                    <img
                      src={`https://dummyimage.com/200x200/${getRandomColor()}/ffffff.png&text=${
                        tenant.displayName ? tenant.displayName : tenant.tenantId
                      }`}
                      alt={tenant.tenantId}
                    />
                  )}
                  <br />
                  {tenant.displayName ? tenant.displayName : tenant.tenantId}
                  <StyledDescriptionDiv></StyledDescriptionDiv>
                  <StyledButtonContainer>
                    <Button data-testid="selectMunicipalityButton" size="large" type="primary">
                      <Link to={`/${tenant.tenantId}`}>{t('general:chooseThisMunicipality')}</Link>
                    </Button>
                  </StyledButtonContainer>
                </StyledTypeContainer>
              ))}
          </StyledFlexbox>
        </StyledContainer>
        <StyledBackgroundIcon component={GeosecmaIcon} role={'presentation'} />
      </SelectCol>
    </Row>
  );
};

SelectMunicipality.propTypes = {
  /**
   * Tenants is an array of { tenantId: '', displayName: ''}
   */
  tenants: PropTypes.array
};

SelectMunicipality.defaultProps = {
  tenants: [
    { tenantId: 'local', displayName: 'Gislaved' },
    { tenantId: 'local', displayName: 'Gislaved2' },
    { tenantId: 'local', displayName: 'Gislaved3' }
  ]
};

export default SelectMunicipality;
